import $http from '../../axios';
import {Notification, MessageBox} from 'element-ui';

// Cargar documento
export async function addDocument({state, commit}) {

    let form_data = new FormData();

    form_data.append('year', state.data.year);
    form_data.append('file', state.data.file);

    commit('setPreloader', true);

    await $http.post('/api/presupuesto-ventas', form_data)
        .then((response) => {
            commit('setPreloader', false);
            Notification.success({
                title: 'Éxito!',
                message: response.data.message,
                type: 'success',
                duration: 3000,
                customClass: 'notification-box',
            });

            commit('resetData');
        })
        .catch((error) => {
            commit('setPreloader', false);

            let message;

            if (error.response.status === 422) {
                message = 'Algunos campos no se registraron correctamente';
            } else {
                message = error.message;
            }

            MessageBox.alert(message, 'Error', {
                confirmButtonText: 'Aceptar',
                type: 'error'
            });
        });
}

/**
 * Descargar plantilla
 */
export async function downloadTemplate({}) {
    await $http({
        url: '/api/descargar-plantilla-cargue-presupuesto',
        method: 'GET',
        responseType: 'blob'
    })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Plantilla cargue presupuest.xlsx');
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 3000,
                customClass: 'notification-box'
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/sales-budgets/actions.js